<script>
import { 
  getCouponsByIdApi,
  getDistributeRecordsByCouponIdApi,
  uploadCouponsSendFileApi,
  secondaryDistributionCouponsApi
} from "api/user";
import { Dialog } from "vant";


export default {
  data() {
    return {
      couponsId: this.$route.query.couponsId,
      couponsInfo: {},
      distributeRecords: [],
      couponSendType: 0,    //发券模式 0 手动 1 批量导入
      mobile: '',
      deno: '',
      couponsList: [],
      fileList:[],
      currentPage: 1,
      itemsPerPage: 5,
      totalItems: 0,
    }
  },
  mounted() {
    this.getCouponsById()
    this.getDistributeRecords()
  },
  methods: {
    getDistributeRecords(){
      let params = {
        couponsId: this.couponsId,
        page: this.currentPage,
        pageSize: this.itemsPerPage
      }
      getDistributeRecordsByCouponIdApi(params).then(({status, data, message}) => {
        if(status == 200){
          this.distributeRecords = data.records
          this.totalItems = data.total
        }else{
          this.$alert(message)
        }
      })
    },
    getCouponsById(){
      getCouponsByIdApi(this.couponsId).then(res => {
        if(res.status == 200){
          this.couponsInfo = res.data
        }
      })
    },
    switchMode(mode){
      this.couponSendType = mode
      this.couponsList = []
      if(mode == 0){
        this.fileList = []
      }
    },
    inputDeno(value) {
      const numValue = value
        .replace(/。/g, '.')
        .replace(/[^0-9.]/g, '')
        .replace(/\.{2,}/g, '.')
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      this.deno = numValue
    },
    setDeno(value){
      this.deno = value
    },
    addCoupon(){
      if (!this.$regPhone(this.mobile)) {
        this.$toast('请输入正确的手机号', 4000)
        return
      }
      //统计卡券总额
      let totalAmount = this.couponsList.reduce((acc, cur) => acc + Number(cur.deno), 0)
      totalAmount += Number(this.deno)
      if (totalAmount > this.couponsInfo.couponsBalance) {
        this.$toast("分发总额不能超出卡券余额", 4000);
        return
      }
      //添加发券记录
      this.couponsList.push({
        mobile: this.mobile,
        deno: this.deno
      })
      this.mobile = ''
      this.deno = ''
    },
    removeCoupon(index){
      this.couponsList.splice(index, 1)
    },
    beforeRead(files, detail) {
      console.log('files1', files);
      this.fileList = []
      let suffix = files.name.split('.').pop()
      if (!suffix.match(/xlsx/)) {
        this.$toast('请上传.xlsx文件', 4000);
        return false;
      }
      return true
    },
    async afterRead(files, detail) {
      const formData = new FormData();
      formData.append('file', files.file)
      this.$loading("正在上传...");
      await uploadCouponsSendFileApi(this.couponsId, formData).then(({status, data, message}) => {
        this.$clear()
        if(status == 200){
          this.couponsList = data
        }else{
          this.$toast(message, 4000);
        }
      })
    },
    deleteFile(files, detail){
      this.couponsList = []
      return true
    },
    downloadTemplate() {
      // 检测是否是手机端
      if (this.isMobile()) {
        this.$toast('手机端暂不支持下载', 4000)
      } else {
        this.downloadFromServer();
      }
    },
    isMobile() {
      const ua = window.navigator.userAgent.toLowerCase();
      // 检测手机设备
      const isMobileDevice = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(ua);
      // 检测iPad（iPadOS 13+的UserAgent像Mac，需要额外检测）
      const isIPad = /ipad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      // 检测微信浏览器
      const isWeChat = ua.indexOf('micromessenger') !== -1;
      // 检测电脑微信（WindowsWechat 或 MacWechat）
      const isPCWeChat = isWeChat && (/windowswechat/i.test(ua) || /macwechat/i.test(ua) || (!isMobileDevice && !isIPad));
      
      // 手机端：手机设备 或 (微信浏览器且不是电脑微信)
      return isMobileDevice || isIPad || (isWeChat && !isPCWeChat);
    },
    downloadFromServer() {
      // 电脑端请求后端接口下载
      const xhr = new XMLHttpRequest();
      xhr.open('GET', '/api/v1.0/download/couponsSend/template?t=' + Date.now(), true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = xhr.response;
          const contentDisposition = xhr.getResponseHeader('Content-Disposition');
          let fileName = '分发模板.xlsx';
          if (contentDisposition) {
            const match = contentDisposition.match(/filename=(.+)/);
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
            }
          }
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          this.$toast('下载成功', 2000);
        } else {
          this.$toast('下载失败，请稍后重试', 3000);
        }
      };
      xhr.onerror = () => {
        this.$toast('下载失败，请稍后重试', 3000);
      };
      xhr.send();
    },
    dialogHandle(title, message){
      return Dialog.confirm({
        title: title,
        message: message,
        messageType: 'html',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => true).catch(() => false);
    },
    async submitHandle(){
      // 验证必填项
      if(this.couponSendType == 0 && this.couponsList.length == 0){
        this.$toast('请添加发券记录', 4000)
        return
      }
      if(this.couponSendType == 1 && this.fileList.length == 0){
        this.$toast('请上传文件', 4000)
        return
      }
      if(this.couponSendType == 1 && this.fileList.length != 0 && this.couponsList.length == 0){
        this.$toast('excel内容不匹配，请重新上传文件!', 4000)
        return
      }
      let totalAmount = this.couponsList.reduce((acc, cur) => acc + Number(cur.deno), 0)
      let res = await this.dialogHandle(
        '确认进行分发操作？', 
        '分发条数：<span style="color:red;">' + this.couponsList.length + '</span>'
        + '\n分发总额：<span style="color:red;">' + totalAmount + '</span>')
      if(!res) return

      // 构建 FormData 对象
      const formData = new FormData();
      formData.append('couponId', this.couponsId);
      formData.append('couponSendType', Number(this.couponSendType));
      this.couponsList.forEach((item, index) => {
          formData.append(`coupons[${index}].mobile`, item.mobile);
          formData.append(`coupons[${index}].deno`, item.deno);
      });

      this.$loading("正在进行分发操作...");
      secondaryDistributionCouponsApi(formData).then(res => {
        this.$clear()
        if(res.status == 200){
          this.$successSync("分发成功");
          this.getCouponsById()
          this.getDistributeRecords()
          this.couponsList = []
          if(this.couponSendType == 0){
            this.deno = ''
            this.mobile = ''
          }else{
            this.fileList = []
          }
        } else {
          this.$toast(res.message, 6000);
          this.$clear()
        }
      }).catch(() => {
        this.$clear()
      })
    },
  }
}
</script>

<template>
  <div class="page">
    <!-- Header -->
    <div class="header">
      <button class="btn-back" @click="$router.back()" aria-label="返回">←</button>
      <span class="header-title">券二次分发</span>
    </div>

    <!-- Coupon Info Card -->
    <div class="coupon-card">
      <div class="coupon-card-inner">
        <div class="coupon-card-row">
          <span class="coupon-name">
            <van-icon name="coupon" size="16" class="coupon-icon" style="margin-right: 5px;" />
            <span> {{ couponsInfo.couponsMouldShowName }} </span>
          </span>
        </div>
        <div class="coupon-amount">{{ couponsInfo.couponsBalance }}</div>
        <div class="coupon-meta">
          <span>🕗 有效期至 {{ couponsInfo.couponsEndDate }}</span>
        </div>
      </div>
    </div>

    <!-- Mode Tabs -->
    <div class="mode-tabs">
      <button :class="['mode-tab', couponSendType == 0 ? 'active' : '']" @click="switchMode(0)">
        <span class="tab-icon">✍️</span> 手动发券
      </button>
      <button :class="['mode-tab', couponSendType == 1 ? 'active' : '']" @click="switchMode(1)">
        <span class="tab-icon">📁</span> 批量导入
      </button>
    </div>

    <div id="panel-manual">
      <!-- Manual Mode -->
      <div class="section-card" v-if="couponSendType == 0">
        <div class="section-title"><span class="dot"></span>输入手机号与面值</div>

        <!-- Input Row -->
        <div class="input-row">
          <div class="input-group phone">
            <label>手机号码</label>
            <van-field
              v-model="mobile"
              placeholder="请输入手机号码"
              maxlength="11"
              type="number"
            />
          </div>
          <div class="input-group amount">
            <label>面值</label>
            <div class="input-wrap">
              <van-field
                v-model="deno"
                placeholder="请输入面值"
                @input="inputDeno($event)"
              />
            </div>
          </div>
          <button class="btn-row-action" @click="addCoupon()" title="添加">+</button>
        </div>

        <!-- Quick amounts -->
        <div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:10px;">
          <button class="btn-clear-upload" style="font-size:11px;padding:4px 10px;" @click="setDeno(10)">10</button>
          <button class="btn-clear-upload" style="font-size:11px;padding:4px 10px;" @click="setDeno(20)">20</button>
          <button class="btn-clear-upload" style="font-size:11px;padding:4px 10px;" @click="setDeno(50)">50</button>
          <button class="btn-clear-upload" style="font-size:11px;padding:4px 10px;" @click="setDeno(100)">100</button>
          <button class="btn-clear-upload" style="font-size:11px;padding:4px 10px;" @click="setDeno(200)">200</button>
        </div>

        <!-- Entry List -->
        <div class="entry-list" id="entryList">
          <div class="empty-state" id="entryEmpty" v-show="couponsList.length == 0">
            <div class="icon">📝</div>
            <div class="text">暂无添加记录，请在上方输入手机号和面值</div>
          </div>
          <div 
            class="entry-item" 
            v-for="(item, index) in couponsList" 
            :key="index" 
            v-show="couponsList.length > 0"
          >
            <span class="entry-index">{{ index + 1 }}</span>
            <span class="entry-phone">{{ item.mobile }}</span>
            <span class="entry-amount">{{ item.deno }} </span>
            <button class="btn-entry-del" @click="removeCoupon(index)" title="删除">✕</button>
          </div>
        </div>

        <div style="display:flex;justify-content:space-between;align-items:center;margin-top:12px;">
          <span style="font-size:13px;color:#94a0b0;">共 
            <strong id="entryCount" style="color: #1a2332;">{{ couponsList.length }}</strong>条记录
          </span>
          <span style="font-size:13px;color:#94a0b0;">合计总额
            <strong id="entryTotal" style="color:#4f6ef6;">
              {{ this.couponsList.reduce((acc, cur) => acc + Number(cur.deno), 0).toFixed(2) }}
            </strong>
          </span>
        </div>
      </div>

      <!-- Batch Mode -->
      <div class="section-card" v-else>
        <div class="section-title">
          <span class="dot"></span>
          上传 Excel 文件批量发券
          <a href="#" @click.prevent="downloadTemplate()" style="color: #4f6ef6;">下载模板</a>
        </div>
        <van-uploader 
          v-model="fileList"
          accept=".xlsx" async
          :before-read="beforeRead" 
          :after-read="afterRead"
          :before-delete="deleteFile"
        >
          <div class="upload-zone" id="uploadZone" v-show="fileList.length == 0">
            <div class="upload-icon" v-show="fileList.length == 0">📤</div>
            <div class="upload-title">点击上传或重新选择 Excel 文件</div>
            <div class="upload-hint">
              仅支持 .xlsx 格式
            </div>
          </div>
        </van-uploader>
      </div>
    </div>

    <!-- Submit -->
    <button class="btn-submit" @click="submitHandle()">
      <span class="spinner"></span> 确认分发
    </button>
    <div style="text-align:center;margin-top:6px;">
      <span style="font-size:13px;color: #695858;" id="submitHint">请添加记录或上传文件,单次分发限制100张</span>
    </div>

    <!-- Distribution History -->
    <div class="section-card" style="margin-top:18px;">
      <div class="section-title"><span class="dot"></span>分发记录</div>
      <div id="historyList">
        <div class="history-item" v-for="(item, index) in distributeRecords" :key="index">
          <div class="history-avatar success">✓</div>
          <!-- <div class="history-avatar partial">!</div> -->
          <div class="history-info">
            <div class="top">
              <span class="name">{{ ['手动分发','批量分发'][item.type] }}</span>
              <span class="time">{{item.createTime}}</span>
            </div>
            <div class="sub">{{ item.num }} 条记录，合计 {{ item.deno }} · 分发成功</div>
          </div>
        </div>
        <div class="history-item" v-show="distributeRecords.length == 0">
          <div class="history-avatar partial">0</div>
          <div class="history-info">
            <div class="top">
              <span class="name">暂无分发记录</span>
            </div>
            <div class="sub">暂无分发记录</div>
          </div>
        </div>
        <van-pagination 
          v-show="totalItems > 5"
          v-model="currentPage" 
          :total-items="totalItems" 
          :items-per-page="itemsPerPage"
          @change="getDistributeRecords"
          mode="simple"
        />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.page {
    max-width: 640px;
    margin: 0 auto;
    padding: 16px 16px 40px;
}
/* ── Header ──────────────────────── */
.header {
  display: flex; align-items: center; gap: 10px;
  padding: 8px 0 16px;
}
.btn-back {
  width: 36px; height: 36px; border-radius: 50%;
  border: 1px solid #e8ecf1; background: #fff;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; font-size: 16px; color: #5a6878;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1); flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
.btn-back:hover { background: #f8f9fb; border-color: #cdd4de; }
.btn-back:active { transform: scale(0.95); }
.header-title {
  font-size: 18px; font-weight: 700; color: #1a2332;
  letter-spacing: -0.3px;
}

/* ── Coupon Info Card ────────────── */
.coupon-card {
  background: linear-gradient(135deg, #4f6ef6 0%, #6c5ce7 100%);
  border-radius: 18px;
  padding: 20px 22px;
  color: #fff;
  margin-bottom: 16px;
  box-shadow: 0 8px 28px rgba(79,110,246,0.28);
  position: relative;
  overflow: hidden;
}
.coupon-card::before {
  content: '';
  position: absolute; top: -30px; right: -20px;
  width: 120px; height: 120px;
  border-radius: 50%;
  background: rgba(255,255,255,0.08);
}
.coupon-card::after {
  content: '';
  position: absolute; bottom: -40px; left: -30px;
  width: 100px; height: 100px;
  border-radius: 50%;
  background: rgba(255,255,255,0.06);
}
.coupon-card-inner { position: relative; z-index: 1; }
.coupon-card-row {
  display: flex; align-items: center; justify-content: space-between;
  gap: 12px;
}
.coupon-name {
  font-size: 14px; font-weight: 600;
  background: rgba(255,255,255,0.18);
  padding: 4px 12px; border-radius: 14px;
  display: flex;
  letter-spacing: 0.2px;
  align-items: flex-end;
}
.coupon-status {
  font-size: 12px; padding: 3px 10px; border-radius: 10px;
  background: rgba(255,255,255,0.22);
  font-weight: 500;
}
.coupon-amount {
  font-size: 36px; font-weight: 800;
  letter-spacing: -1px; margin: 8px 0 2px;
}
.coupon-amount small { font-size: 16px; font-weight: 500; }
.coupon-meta {
  display: flex; gap: 20px; margin-top: 8px;
  font-size: 12px; opacity: 0.85;
}
.coupon-meta span { display: flex; align-items: center; gap: 4px; }

/* ── Mode Tabs ───────────────────── */
.mode-tabs {
  display: flex; gap: 0;
  background: #ffffff;
  border-radius: 12px;
  padding: 4px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.04);
  border: 1px solid #e8ecf1;
}
.mode-tab {
  flex: 1; text-align: center;
  padding: 10px 16px; border-radius: 9px;
  font-size: 14px; font-weight: 600;
  cursor: pointer; transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
  color: #94a0b0; border: none;
  background: transparent; font-family: inherit;
  position: relative;
}
.mode-tab.active {
  background: #4f6ef6;
  color: #fff;
  box-shadow: 0 2px 8px rgba(79,110,246,0.3);
}
.mode-tab .tab-icon { margin-right: 4px; font-size: 15px; }


/* ── Section Card ────────────────── */
.section-card {
  background: #ffffff;;
  border-radius: 12px;
  padding: 18px 20px;
  margin-bottom: 14px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.04);
  border: 1px solid #e8ecf1;
}
.section-title {
  font-size: 14px; font-weight: 700;
  color: #1a2332;
  margin-bottom: 14px;
  display: flex; align-items: center; gap: 6px;
}
.section-title .dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: #4f6ef6;
}


/* ── Input Row ───────────────────── */
.input-row {
  display: flex; gap: 10px; align-items: flex-end;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.input-group {
  display: flex; flex-direction: column; gap: 4px;
}
.input-group .van-field{
  border-radius: 5px;
  border: 1px solid #dddddd;
}

.input-group.phone { flex: 1.4; min-width: 140px; }
.input-group.amount { flex: 1; min-width: 100px; }
.input-group label {
  font-size: 11px; font-weight: 600; color: #94a0b0;
  text-transform: uppercase; letter-spacing: 0.5px;
}

.btn-row-action {
  width: 36px; height: 36px; border-radius: 50%;
  border: 1.5px solid #e8ecf1;
  background: #f7f9fc;
  cursor: pointer; font-size: 18px; color: #94a0b0;
  display: flex; align-items: center; justify-content: center;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1); flex-shrink: 0;
  margin-bottom: 4px;
}
.btn-row-action:active { border-color: #4f6ef6; color: #4f6ef6; background: #eef1fe; }

.btn-clear-upload {
  padding: 6px 14px; border-radius: 14px;
  border: 1px solid #e8ecf1; background: #ffffff;;
  font-size: 12px; color: #94a0b0; cursor: pointer;
  font-family: inherit; transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
}

/* ── Entry List ──────────────────── */
.entry-list { display: flex; flex-direction: column; gap: 8px; }
.entry-item {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 12px; background: #f7f9fc;;
  border-radius: 8px;
  border: 1px solid #e8ecf1;
  animation: fadeIn 200ms ease-out;
  flex-wrap: wrap;
}
@keyframes fadeIn { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
.entry-index {
  width: 24px; height: 24px; border-radius: 50%;
  background: #eef1fe; color: #4f6ef6;
  font-size: 11px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.entry-phone { flex: 1; font-size: 14px; font-weight: 500; color: #1a2332; min-width: 100px; }
.entry-amount { font-size: 15px; font-weight: 700; color: #4f6ef6; white-space: nowrap; }
.entry-amount small { font-size: 12px; font-weight: 400; color: #94a0b0; }
.btn-entry-del {
  width: 28px; height: 28px; border-radius: 50%;
  border: none; background: transparent;
  cursor: pointer; font-size: 14px; color: #94a0b0;
  display: flex; align-items: center; justify-content: center;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1); flex-shrink: 0;
}
.btn-entry-del:hover { background: #fef2f2; color: #ef4444; }

/* ── Empty State ─────────────────── */
.empty-state {
  text-align: center; padding: 24px 16px;
  color: #94a0b0;
}
.empty-state .icon { font-size: 40px; margin-bottom: 8px; }
.empty-state .text { font-size: 13px; }

/* ── Upload Zone ─────────────────── */
.upload-zone {
  border: 2px dashed #d0d7e4;
  border-radius: 12px;
  padding: 32px 20px;
  text-align: center;
  cursor: pointer;
  background: #fafbfd;
  position: relative;
}
.upload-icon {
  width: 52px; height: 52px; border-radius: 50%;
  background: #eef1fe; margin: 0 auto 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 24px;
}
.upload-title { font-size: 16px; font-weight: 600; color: #1a2332; margin-bottom: 4px; }
.upload-hint { font-size: 13px; color: #94a0b0; }
.upload-hint a { color: #4f6ef6; text-decoration: none; font-weight: 500; }
.upload-hint a:hover { text-decoration: underline; }

/* ── Submit Button ───────────────── */
.btn-submit {
  width: 100%; height: 50px;
  border: none; border-radius: 12px;
  background: #4f6ef6;
  color: #fff; font-size: 16px; font-weight: 700;
  cursor: pointer; font-family: inherit;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(79,110,246,0.32);
  letter-spacing: 0.5px;  
  margin-top: 6px;
  transform: translateY(0px);
}
.btn-submit:active {
   background: #3b57d3;
}

/* ── History ─────────────────────── */

.history-item {
  display: flex; align-items: center; gap: 12px;
  padding: 12px 14px; border-bottom: 1px solid #f0f2f6;
  transition: background 200ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}
.history-item:last-child { border-bottom: none; }
.history-item:hover { background: #fafbfd; }
.history-avatar {
  width: 38px; height: 38px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 16px; flex-shrink: 0;
  font-weight: 700; color: #fff;
}
.history-avatar.success { background: #d1fae5; color: #065f46; }
.history-avatar.partial { background: #fef3c7; color: #92400e; }
.history-info { flex: 1; min-width: 0; }
.history-info .top {
  display: flex; justify-content: space-between; align-items: baseline;
}
.history-info .name { font-size: 14px; font-weight: 600; color: #1a2332; }
.history-info .time { font-size: 11px; color: #94a0b0; flex-shrink: 0; }
.history-info .sub {
  font-size: 12px; color: #94a0b0; margin-top: 2px;
}


/deep/ .van-uploader, /deep/ .van-uploader__input-wrapper{
  width:100%;
}
.van-uploader__file{
  width: 100%;
}
.van-uploader__file-name{
  font-weight:600;
}
/deep/ .van-uploader__wrapper{
  justify-content: center;
}
</style>